import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import LngDetector from "i18next-browser-languagedetector";
import { reactI18nextModule } from "react-i18next";

i18n
  .use(Backend)
  .use(LngDetector)
  .use(reactI18nextModule)
  .init({
    resGetPath: `${process.env.PUBLIC_URL}/locales/__lng__/__ns__.json`,
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
      addPath: `${process.env.PUBLIC_URL}/locales/add/{{lng}}/{{ns}}`,
      allowMultiLoading: false
    },

    fallbackLng: "de",

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    debug: true,

    interpolation: {
      escapeValue: false // not needed for react!!
    },

    react: {
      wait: true
    }
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/utils/i18n.js